export const participantsOptions = { participant: 'participant', bookingPerson: 'bookingPerson' };

export const PARTNER_DISCOUNT = 0.1;
export const EARLY_DISCOUNT = 0.1;

export const DISCOUNT_OPTIONS = {
  none: 'none',
  partnerDiscount: 'partnerDiscount',
  earlyBird: 'earlyBird'
};
export const COST_FOR_PARTICIPANT_MATERIAL_CONSTANT = 0.1;
export const VAT_BOOKING_PROCESS = 0;

export const ParticipantStatus = {
  ToBeInvited: 1,
  ApprovalNeeded: 2,
  Reserved: 3,
  ApprovalDeclined: 4,
  Cancelled: 5,
  RegistrationConfirmed: 6,
  Invited: 7,
  WaitingCancelled: 8,
  RegistrationPending: 10
};

export const euCountriesIds = [
  16, 24, 26, 99, 57, 58, 60, 65, 71, 76, 90, 101, 103, 111, 136, 134, 135, 154, 166, 179, 184, 189,
  200, 198, 69, 195
];

export const AdditionalAddressTypes = {
  Billing: {
    name: 'billingAddress',
    radioName: 'billingAddressRadio',
    title: 'Booking.confirmBillingAddress',
    subTitle: 'Booking.billingAddress'
  },
  Communication: {
    name: 'communicationAddress',
    radioName: 'communicationAddressRadio',
    title: 'Booking.confirmCommunicationAddress',
    subTitle: 'Booking.communicationAddressHeader'
  }
};
